<div class="container">
  <div class="support-wrapper">
    <div class="support-left">
      <div class="contact-us-title column">
        <h3>{{ "customer-support.need-help" | translate }}</h3>
        <p>{{ "customer-support.need-help-desc" | translate }}</p>
      </div>
      <div class="call-to-action">
        <a
          title="10505"
          href="tel:10505"
          class="btn btn-primary d-inline-block"
        >
        <!-- {{ "customer-support.toll-free" | translate }}:  -->
          <span>10505</span>
        </a>
      </div>
    </div>
    <div
      class="support-right"
      [innerHTML]="helpSVG | safeHTML"
      style="width: 452px; height: 279px"
    ></div>
  </div>
</div>
